/* eslint-disable react/jsx-no-useless-fragment */
import React, { FC } from 'react';
import { Navigate } from 'react-router-dom';
import RouteUrlPaths from '../../RouteUrlPaths';
import ManageUserAccessStore from '../../stores/ManageUserAccessStore';

interface ProtectedProductRouteProps {
  manageUserAccessStore: ManageUserAccessStore;
}

const ProtectedProductRoute: FC<ProtectedProductRouteProps> = (props) => {
  const { manageUserAccessStore, children } = props;
  if (!manageUserAccessStore.showProductPage()) {
    return <Navigate to={RouteUrlPaths.Frontpage} />;
  }
  return <>{children}</>;
};

export default ProtectedProductRoute;
